import React from 'react';
import ReactDOM from 'react-dom';
import App from './app';

/* eslint-disable */
// Define allowed paths
const allowedPaths = [
  '/',
  '/about-us',
  '/whats-new',
  '/search-results',
  '/search-result-details',
  '/taxonomy-search',
  '/decision-tree',
];

const isAllowedPath = allowedPaths.some( path => {
  if ( path === '/' ) {
    return window.location.pathname === '/';
  }
  return window.location.pathname.startsWith(path);
});

// Inject Hotjar only in production + allowed routes
if (
  process.env.REACT_APP_APP_ENV === 'production' &&
  isAllowedPath &&
  !window.hj
) {
  (function(h,o,t,j,a,r){
    h.hj = h.hj || function(){ (h.hj.q = h.hj.q || []).push(arguments) };
    h._hjSettings = { hjid: 6667022, hjsv: 6 };
    a = o.getElementsByTagName('head')[0];
    r = o.createElement('script');
    r.async = 1;
    r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
    a.appendChild(r);
  })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');
}
/* eslint-disable */

ReactDOM.render(<App />, document.getElementById('root'));